import { render, staticRenderFns } from "./TrailPresentationDialog.vue?vue&type=template&id=491d5821&scoped=true"
import script from "./TrailPresentationDialog.vue?vue&type=script&lang=js"
export * from "./TrailPresentationDialog.vue?vue&type=script&lang=js"
import style0 from "./TrailPresentationDialog.vue?vue&type=style&index=0&id=491d5821&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "491d5821",
  null
  
)

export default component.exports